module.exports = __webpack_public_path__ + "static/6305-woodrose-47-b1433d50bea6249fddc9c5f658be29f2.jpg";